var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('activation-delivered-content-provider',{scopedSlots:_vm._u([{key:"default",fn:function(ref){
var task = ref.task;
var isLoading = ref.isLoading;
var errors = ref.errors;
var errorMessage = ref.errorMessage;
var content = ref.content;
var goToContent = ref.goToContent;
return [_c('activation-delivered-content-view',{attrs:{"task":task,"is-loading":isLoading,"errors":errors,"error-message":errorMessage,"content":content},on:{"go-to-content":goToContent}})]}}])})}
var staticRenderFns = []

export { render, staticRenderFns }